<template>
    <div class="wrapper">
      <div class="container">
        <div class="right-column" :class="{ 'hovered': isHoverRight }" @mouseover="isHoverRight = true">
          <h2>change Password</h2>
          <el-form :model="changePasswordForm" :rules="changePasswordRules" ref="changePasswordForm">
            <el-form-item label="New Password" prop="newPassword">
              <el-input  auto-complete="new-password"  size="medium" prefix-icon="el-icon-lock" type="password" v-model="changePasswordForm.newPassword" placeholder="Please enter a new password"></el-input>
            </el-form-item>
            <el-form-item label="Confirm the new password" prop="confirmPassword">
              <el-input  auto-complete="new-password"  size="medium" prefix-icon="el-icon-lock" type="password" v-model="changePasswordForm.confirmPassword" placeholder="Please confirm new password"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="medium" @click="changePassword">Confirm the changes</el-button>
              <el-button type="danger" size="medium" @click="cancelChangePassword">Cancel</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import request from '@/utils/request';
  import md5 from 'js-md5';
  
  export default {
    name: "ChangePassword",
    data() {
      return {
        changePasswordForm: {
          newPassword: '',
          confirmPassword: ''
        },
        changePasswordRules: {
          newPassword: [
            { required: true, message: 'Please enter a new password', trigger: 'blur' },
            { min: 6, message: 'Password length cannot be less than 6 characters', trigger: 'blur' }
          ],
          confirmPassword: [
            { required: true, message: 'Please confirm new password', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (value !== this.changePasswordForm.newPassword) {
                  callback(new Error('The passwords entered twice are inconsistent'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ]
        },
        isHoverRight: false,
      };
    },
    methods: {
      changePassword() {
        this.$refs.changePasswordForm.validate((valid) => {
          if (valid) {
            console.log(this.$store.state.editUserName)
            console.log( md5(this.changePasswordForm.newPassword))

            request.get("/users/editPassword",{
                params:{
                    userName :this.$store.state.editUserName,
                    password : md5(this.changePasswordForm.newPassword)
                }
            }).then(res =>{
                console.log("forget the password",res)
                if(res.code === "SUCCESS"){
                    this.$message.success("Successfully modified")
                    this.$store.state.editUserName = ''
                    this.$router.push("/login")
                }else{
                    this.$message("Modification failed, please re-enter the verification interface to verify.")
                }
            })
          } else {
            return false;
          }
        });
      },
      cancelChangePassword() {
        this.$router.push('/login'); // 跳转至个人资料页面或其他页面
      }
    },
  };
  </script>
  
  <style scoped>
  .wrapper {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #04112b;
  }
  
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 800px;
  }
  
  .right-column {
    flex: 1;
    padding: 20px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    transition: transform 0.5s ease, box-shadow 0.5s ease;
    transform-origin: center center;
  }
  
  .right-column.hovered {
    transform: perspective(1000px) scale(1.2) rotateY(0deg);
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  }
  
  .el-input {
    margin-bottom: 10px;
  }
  
  .el-button {
    margin-top: 10px;
  }
  
  .forgot-password-link {
    color: #999;
    font-size: 12px;
    margin-left: 10px;
  }
  </style>